import { render } from "./laborPracticeMuseum.vue?vue&type=template&id=dbfb1b1e&scoped=true"
import script from "./laborPracticeMuseum.vue?vue&type=script&lang=js"
export * from "./laborPracticeMuseum.vue?vue&type=script&lang=js"

import "./laborPracticeMuseum.vue?vue&type=style&index=0&id=dbfb1b1e&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfb1b1e"]])

export default __exports__